import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import ServicesMarquee from '../components/ServicesMarquee'
import ServicesNav from '../components/ServicesNav'
import ServiceGallery from '../components/ServiceGallery';
import { Link } from 'react-router'
const WebDevelopment = () => {
  return (
<>
<Helmet>
  <title>Web Development Services - Om Softwares | Custom Websites & E-commerce</title>
  <meta name="description" content="Get high-performance, responsive websites from Om Softwares. Custom web development, MERN stack, e-commerce solutions, and website redesign services in Nangal, Punjab." />
  <meta property="og:title" content="Web Development Services - Om Softwares" />
  <meta property="og:description" content="Custom web development, MERN stack, e-commerce solutions, and responsive website design." />
  <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
  <meta property="og:url" content="https://omsoftwares.in/web-development" />
  <meta property="og:type" content="website" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Web Development Services - Om Softwares" />
  <meta name="twitter:description" content="Custom web development, MERN stack, e-commerce solutions, and responsive website design." />
  <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
</Helmet>
<main>
    < Breadcrumb name="Web Development"/>
        <div className="service-details pt-125 ">
            <div className="container">
                <div className="row mt-none-30 align-items-center">
                    <div className="col-lg-6 mt-30">
                        <div className="section-title">
                            <span className="sub-title wow fadeInRight" data-wow-duration=".7s">Om Softwares - Best Web Development Company</span>
                            <h3 className="title xb-split-text split-in-right mb-15">Building Seamless & Responsive Websites <span>with Om Softwares</span></h3>

                        </div>
                        <div className="service-single-content">
                            
                            <p className="mb-40 wow fadeInUp" data-wow-duration=".7s">Our mission is to empower businesses by delivering high-performance, responsive websites that enhance their digital presence. We are committed to creating web solutions that not only meet but exceed our clients' expectations. Through innovation, precision, and seamless user experiences.</p>
                            <p className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration=".7s">
                                Our vision is to be a leader in web development, known for our unwavering commitment to excellence, scalability, and creating websites that drive business success.
                            </p>
 
                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="service-details_image">
                            <img className="ukiyo" data-u-speed="1.2" src="assets/img/about/web-development-hero.webp" alt="Om Softwares Web Development Services"/>
                        </div>
                    </div>
                </div>
                <div className="row pt-80">
                    <div className="col-lg-8">
                        <div className="sv-details mt-30">
                            <h3 className="sv-title">Our mission is to create high-performance websites <br/> that enhance your digital presence and provide seamless user experiences!</h3>
                            <ul className="sv-list">
                                <li>Responsive web design optimized for all devices</li>
                                <li>Custom website development tailored to your business needs</li>
                                <li>Seamless integration with third-party tools and services</li>
                                <li>Ongoing support and maintenance for continuous website improvement</li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 mt-30">
                        <div className="sd-details">
                            <h3 className="sd-title">SEARCH ENGINE OPTIMISATION</h3>
                            <p className="sd-content pb-60">Our vision is to be a leader in the field of SEO, helping businesses rank higher and drive organic traffic through tailored strategies, cutting-edge techniques, and a commitment to delivering measurable results.</p>
                            <Link to="/contact" className="sd-button">Let’s Talk <img src="assets/img/icon/SD-01.svg" alt=""/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section className="service_details-slider z-3 pt-130">
                   
        <ServiceGallery img1="assets/img/searvice/sg_01.jpg" img2="assets/img/searvice/sg_02.jpg"
                        img3="assets/img/searvice/sg_03.jpg" img4="assets/img/searvice/sg_04.jpg"
                        img5="assets/img/searvice/sg_05.jpg" img6="assets/img/searvice/sg_01.jpg"/>
            <div className="container">
                <h3 className="sd-contents pt-125">Great web development ensures your website is functional, responsive, and easy to navigate & <br/> enhances user experience without any disruptions. Bonus points for when it also looks <br/> sleek, modern, and visually appealing!</h3>

            </div>
        </section>
        <ServicesMarquee/>
        <ServicesNav prev="VISUAL BRANDING" next="SOCIAL MEDIA MANAGEMENT"/>
</main>

</>
  )
}

export default WebDevelopment
